module.exports = __webpack_public_path__ + "static/media/astronaut.ef7b13d4.svg";